import "../initializers/turbolinks";
import "../initializers/jquery";
import "../initializers/stimulus";
import "../initializers/moment";
import "../initializers/sentry";
import "../initializers/map-polyfills";
import "../initializers/ie-detect";
import "../css/maps.css"; // Load our CSS after all Stimulus controllers (which may pull in library-specific base styles)

window.Scout = {};
